/*  ========================================================================
    # Scripts - Gallery
    ========================================================================  */

/**
 * Script that initializes the lightbox gallery on the page
 */
const Gallery = {
  /**
   * Initialize.
   */
  init() {
    GLightbox({
      selector: '*[data-glightbox]',
      loop: false
    });
  }
};

export default Gallery;
